

import api from "@/services/api.service";
import ShortContact from "@/types/sv-data/users/ShortContact";
import { Component, Emit, Prop, Vue, Watch } from "vue-property-decorator";
import ContactGroupSelect from "../contact-group/ContactGroupSelect.vue";
import ContactEmailSelect from "@/components/contacts/ContactEmailSelect.vue";
import ContactGroup from "@/types/sv-data/contact-groups/ContactGroup";
import { Getter } from 'vuex-class';

@Component({
    components: {
        "contact-group-select": ContactGroupSelect,
        "contact-email-select": ContactEmailSelect
	}
})
export default class NotificationRuleContacts extends Vue {
    @Prop({ type: Boolean, default: false })
    private readOnly: boolean;

    @Prop({ type: Array, required: true })
    private userIds: number[];

    @Prop({ type: Array, required: true })
    private contactGroupIds: string[];

	@Prop({ type: Array, required: true })
	private contactGroups: ContactGroup[];

    @Prop({ type: Array, required: true })
    private emailAddress: string[];

    @Prop({ type: Boolean, default: false })
    private isRequired: boolean;

    @Getter("getFeature") getFeature: (featureName: string[]) => boolean;

    private contacts: ShortContact[] = [];

    private async mounted(): Promise<void> {
        await this.getRequiredContacts();
    }

    private get isContactGroupsEnabled(): boolean {
		return this.getFeature(["Alarms", "SiteMonitor", "Email", "NotificationTemplates", "NotificationGroups"]);
	}

    private get selectedContactGroupIds(): string[] {
        return this.contactGroupIds;
    }

	private get selectedContactGroups(): ContactGroup[] {
		return this.contactGroups;
	}

    private async getRequiredContacts(): Promise<void> {
		if (!this.userIds?.length) {
			this.contacts = [];
			return;
		}

        try {
            this.contacts = await api.getContactsPaginated({
                params: {
                    page: 1,
                    pageSize: 0,
                    searchTerm: "",
                    requiredUserIds: this.userIds
                },
                cancelToken: null
            });
        } catch (error) {
            console.error("Error when getting contacts", error)
        }
    }

    private get selectedContacts(): ShortContact[] {
        const userDetails = this.contacts.filter((contact: ShortContact) => !!contact.userID);
        const emailContacts = !this.emailAddress ? [] : this.emailAddress?.map((emailAddress: string) => {
            return {
                email: emailAddress,
                userID: null,
                fullName: null,
            };
        })

        const userContacts = !this.userIds ? [] : this.userIds.map((userId: number) => {
            const obj = userDetails.firstOrDefault((c: ShortContact) => c.userID === userId);
            return {
                userID: userId,
                fullName: obj?.fullName,
                email: null
            };
        });

        return [...emailContacts, ...userContacts];
    }

    private onContactChange(contacts: ShortContact[]): void {
        const userIds: number[] = [];
        const emailAddresses: string[] = [];

        contacts.forEach((contact: ShortContact) => {
            if (contact.userID) {
                userIds.push(contact.userID);
            } else if (contact.email) {
                emailAddresses.push(contact.email);
            }
        });

        this.emitUpdateUserIds(userIds);
        this.emitUpdateEmailAddress(emailAddresses);
    }

    @Emit("update-user-ids")
    private emitUpdateUserIds(userIds: number[]): number[] {
        return userIds;
    }

    @Emit("update-contact-group-ids")
    private emitUpdateContactGroupIds(contactGroupIds: ContactGroup[]): string[] {
        return contactGroupIds.map(group => group.contactGroupId);
    }

    @Emit("update-email-address")
    private emitUpdateEmailAddress(emailAddress: string[]): string[] {
        return emailAddress;
    }

    @Watch("userIds")
    private async onUserIdsChanged(): Promise<void> {
        // When the userIds prop changes, reload the contacts
        await this.getRequiredContacts();
    }

}
